import React from 'react';

const PageNotFound = () => {
    return (
        <div>
            <h2>page 404</h2>
        </div>
    );
};

export default PageNotFound;